import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertAndSumWeightValues } from '../services/unit-services/weights/weight-convert-and-sum-service';
import Global from '../store/global-selectors';

export const usePackagesWeightInSellerUnit = (packages) => {
  const sellerDefaultWeightUnit = useSelector(Global.selectSellerDefaultWeightUnit);

  return useMemo(() => {
    return convertAndSumWeightValues(
      packages.map((p) => p.weight),
      sellerDefaultWeightUnit,
    );
  }, [packages, sellerDefaultWeightUnit]);
};
